import { call, put, select } from 'redux-saga/effects';
import { getPOTS as getPOTsAda } from '@bitComponents/adabyron/cqv2';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* getPOTs(params) {
  const {
    cqId,
    shippingStepAllowed,
    reduxUpdate,
    normalizeHttpErrors,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const response = yield call(getPOTsAda, { cqId }, context);
    yield put(successUpdate({...response, shippingStepAllowed}));
    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_POTS, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
